<template>
  <div style="border-radius: 30px !important">
    <div>
      <div
        class="header_text count_center"
        style="
          font-size: 24px;
          font-family: PingFang SC;
          font-weight: bold;
          color: #333333;
          margin-bottom: 25px;
        "
      >
        <span style="float: left">
          {{ countData.cityName }}-
          <template v-if="countData.regionType === 6">{{ beforeToCountryName || countData.countryName || "" }}</template>
          <template v-else>{{ countData.countryName || "" }}</template>
        </span>
        <div
          :class="BillItem.concernSign ? 'icon_collect_pre' : 'icon_collect'"
          :style="{ color: BillItem.concernSign ? '#FFBF4D' : '' }"
          style="
            float: left;

            margin-left: 20px;
          "
          @click.stop="followItem"
          v-if="countData.whetherPlatformCorporationLine"
        ></div>
      </div>
      <div style="position: relative;">
        <el-row :gutter="20" style="width: 80%">
          <el-col :span="8" v-if="isOpen">
            <div class="headerItem">
              <div class="" style="color: #999999">
                运输方案：<span style="color: black">{{
                  countData.transportSchemeName || '-'
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                专线渠道名称：<span style="color: black">{{
                  countData.productName
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                专线渠道代码：<span style="color: black">{{
                  countData.carrierProductCode
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                {{ transportCodeMapping[countData.transportTypeCode] || '运输' }}公司：
                <span style="color: black">
                  <template v-if="countData.transportTypeCode === 'KY'">
                    {{ countData.airLineNames }}
                  </template>
                  <template v-else-if="countData.transportTypeCode === 'HY'">
                    {{ countData.shipCompanyNames || '-' }}
                  </template>
                  <template v-else-if="countData.transportTypeCode === 'LY'">
                    {{ countData.landTransportNames || '-' }}
                  </template>
                  <template v-else>-</template>
                </span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div style="color: #999999;overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 2;-webkit-box-orient: vertical;display: -webkit-box;">
                可接货物：
                <el-tooltip placement="top">
                  <div slot="content" style="max-width: 800px;">{{ countData.goodsTypeNames }}</div>
                  <span style="color: black">{{
                    countData.goodsTypeNames
                  }}</span>
                </el-tooltip>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                是否包税：<span style="color: black">{{
                  countData.containsTheTariffs ? "包税" : "不包税"
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8" v-if="countData.chargeType == 'KG'">
            <div class="headerItem">
              <div>
                <span style="color: #999999">{{ countData.isSegment ? '头程' : '' }}体积重比率 ：</span>
                {{ countData.volumeWeightRatio }}
                <el-tooltip class="item" effect="dark" placement="top-start">
                  <div slot="content" style="max-width: 220px">
                    <span>体积重比率用于计算体积重，体积重=长*宽*高/体积重比率</span><br />
                    <span>例如:100CM*100CM*100CM规格的箱子，若体积重比率=6000，则体积重=100*100*100/6000≈167KG</span>
                  </div>
                  <!-- <img style="vertical-align: middle;margin-left: 8px;margin-bottom: 4px;" src="@/assets/imgs/icon_explain.png" alt=""/> -->
                  <i  style="color:#e6a23c;vertical-align: middle;margin-left: 8px;margin-bottom: 4px;font-size:16px" class="el-icon-question"></i>
                </el-tooltip>
              </div>
            </div>
          </el-col>
          <el-col
            :span="8"
            v-show="
              countData.weightVolumeRatioDesc && countData.chargeType == 'CBM'
            "
          >
            <div class="headerItem">
              <div class="" style="color: #999999">
                {{ countData.isSegment ? '头程' : '' }}重量转换：<span style="color: black">{{
                  countData.weightVolumeRatioDesc
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                报价类型：<span style="color: black">{{
                  priceTypeName[countData.priceCode] || '-'
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                派送方式：<span style="color: black">{{ setType(countData.deliveryType || 'empty') }}</span>
                <span style="color:black;" v-if="['HY','KY','LY'].includes(countData.transportTypeCode)&&countData.endDeliveryType||countData.endDeliveryTypes">- {{countData.endDeliveryTypes || countData.endDeliveryType }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8" v-if="countData.deliveryType !== 'ZT'">
            <div class="headerItem">
              <div class="" style="color: #999999">
                海外仓是否支持自提：<span style="color: black">{{
                  countData.selfDelivery === 1
                    ? "是" : countData.selfDelivery === 2
                    ? "否" : '强制自提'
                }}</span>
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="headerItem">
              <div class="" style="color: #999999">
                {{ countData.transportTypeCode === 'LY' ? '车次' : '航期' }}信息：
                <span style="color: black">
                  <template v-if="countData.shippingDateInformation">
                    {{ countData.shippingDateInformation ? countData.shippingDateInformation + '开船' : '-' }}
                  </template>
                  <template v-else>
                    {{ countData.closeWarehouseTime ? `${countData.closeWarehouseTime}截仓${countData.startShipmentTime}起运` : '-' }}
                  </template>
                </span>
              </div>
            </div>
          </el-col>
        </el-row>
        <div v-if="val == 1" class="test">
          <!--            <el-popover-->
          <!--              v-if="countData.isContainerCarrier"-->
          <!--              :popper-options="{-->
          <!--                          boundariesElement: 'body',-->
          <!--                          gpuAcceleration: false,-->
          <!--                        }"-->
          <!--              placement="bottom-start"-->
          <!--              title="企业微信在线客服"-->
          <!--              width="160"-->
          <!--              trigger="hover"-->
          <!--            >-->
          <!--              <div>-->
          <!--                <img-->
          <!--                  style="-->
          <!--                              width: 130px;-->
          <!--                              height: 130px;-->
          <!--                              margin-left: 15px;-->
          <!--                            "-->
          <!--                  :src="countData.wxUrl"-->
          <!--                  alt="微信咨询二维码"-->
          <!--                />-->
          <!--                <p style="margin-left: 3px">扫一扫获取您的专线客服</p>-->
          <!--              </div>-->
          <!--              <div slot="reference"-->
          <!--                   class="zxBtn"-->
          <!--                   style="float: right">-->
          <!--                联系专线-->
          <!--              </div>-->
          <!--            </el-popover>-->

          <!-- <el-popover
            :popper-options="{
              boundariesElement: 'body',
              gpuAcceleration: false,
            }"
            placement="top-start"
            title="企业微信在线客服"
            width="160"
            trigger="hover"
          >
            <div>
              <img
                style="
                            width: 130px;
                            height: 130px;
                            margin-left: 15px;
                          "
                :src="qrCodeImages.wxService"
                alt="微信咨询二维码"
              />
              <p style="margin-left: 3px">扫一扫联系平台客服</p>
            </div>
            <div slot="reference"
                 class="zxBtn"
                 style="float: right">
              联系平台
            </div>
          </el-popover> -->
          <div
            class="gotBtn"
            style="float: right; margin-left: 10px"
            @click="getUsertypeRap"
            v-if="showButton && countData.whetherPlatformCorporationLine"
          >
            立即下单
          </div>
        </div>
        <el-row>

        </el-row>
        <el-row>

        </el-row>

        <div v-if="isTransfer" style="position: relative;margin-bottom: 24px;">
          <span class="transfer-table-tag">转运价</span>
          <transfer-price-table
            :list="countData.transPriceDomList"
            :price-display-type="countData.priceDisplayType"
          />
        </div>
        <div style="position: relative">
          <p class="price-time-range"><span style="color: #FF5D2B">报价有效时间：</span>{{ countData.effectiveStartTime }} - {{ countData.effectiveEndTime }}</p>
          <el-tabs v-model="tabCurrent" class="priceTab" tab-position="top">
            <el-tab-pane :label="countData.isSegment ? '头程报价' : '全包报价'" name="head">
              <span class="transfer-table-tag" v-if="isTransfer">直拼价</span>
              <div class="table">
                <el-table
                  size="mini"
                  border
                  style="width: 100% !important;"
                  :fit="true"
                  :data="filterTableData"
                  :span-method="headSpanMethod"
                  :row-class-name="selectedRowClassName"
                >
                  <el-table-column
                    align="center"
                    :prop="item.prop"
                    :label="item.label"
                    v-for="(item, index) in theadData"
                    :key="index"
                    :min-width="item.label && item.label.includes('目的国') ? '150px' : ''"
                  >
                    <template v-slot:header v-if="item.label && item.label.includes('目的国')">
                      <div style="display:flex;align-items: center;justify-content: center">
                        <span style="margin-right: 10px;">{{ item.label }}</span>
                        <region-filter
                          ref="n1"
                          :key="`n1_${item.prop}`"
                          :list="allRegionList"
                          :isZipCode="checkVisibleLookZipCodeRegion(countData.isSegment ?'head':'all')"
                          type="header"
                          @search="handleRegionSearch"
                          @clear="handleRegionSearchReset"
                          @handleFilter="getRegionForSelect('header')">
                          <div>
                            <el-button style="color:#FF8745;font-size: 12px" type="text" icon="el-icon-search">筛选</el-button>
                          </div>
                        </region-filter>
                      </div>
                    </template>
                    <template v-else-if="item.label && item.label.includes('提取时效')" v-slot:header>
                      <div style="display:flex;align-items: center;justify-content: center">
                        <span style="margin-right: 10px;">{{ item.label }}</span>
                        <el-tooltip
                          content="目的港清关后到门时效"
                          placement="top-start"
                        >
                          <i class="el-icon-question" style="color:#C2C2C2;"></i>
                        </el-tooltip>
                      </div>
                    </template>
                    <template slot-scope="scope">
                      <template v-if="index ===1 && checkVisibleLookZipCodeRegion(countData.isSegment ?'head':'all')">
                        <el-link
                          @click="showZipCodeSearch(countData.isSegment ?'head':'all',scope.row[item.prop], scope.$index)"
                          :underline="false">
                          <template>
                            <div v-html="getRegionHighLight(scope.row[item.prop], 'head')"></div>
                          </template>
                          <!--<template v-else>
                            {{ scope.row[item.prop] ? scope.row[item.prop] : "/" }}
                          </template>-->
                        </el-link>
                      </template>
                      <template v-else-if="index ===1 && !checkVisibleLookZipCodeRegion(countData.isSegment ?'head':'all')">
                        <region-detail
                          :list="regionList"
                          :searchText="(countData.regionType !== 6 || (scope.row[item.prop].includes(endCountryName) && countData.regionType === 6)) ? podlandName : null"
                          :filterCode="headerFilterCode"
                          @show="getRegionList(countData.isSegment ?'head':'all', scope.row[item.prop], scope.$index)">
                          <div>
                            <el-link :underline="false" style="text-decoration: underline;">
                              <template>
                                <div v-html="getRegionHighLight(scope.row[item.prop], 'head')"></div>
                              </template>
                              <!--<template v-else>
                                {{ scope.row[item.prop] ? scope.row[item.prop] : "/" }}
                              </template>-->
                            </el-link>
                          </div>
                        </region-detail>
                      </template>
                      <!-- <template v-else-if="index === 2 && item.label === '可走货物类型'"> -->
                      <template v-else-if="index === 3 && item.label === '可走货物类型'">
                        <goods-detail-list :table-data="goodsDetailList" :table-loading="goodsTableLoading" :countData="countData" @show="getGoodsDetails(scope.row[item.prop])">
                          <div>
                            <el-link type="primary" :underline="false" style="text-decoration: underline;">
                              <span style="overflow: hidden;text-overflow: ellipsis;-webkit-line-clamp: 3;-webkit-box-orient: vertical;display: -webkit-box;">
                                {{ scope.row[item.prop] ? scope.row[item.prop] : "/" }}
                              </span>
                            </el-link>
                          </div>
                        </goods-detail-list>
                      </template>
                      <template v-else-if="isPriceColumn(countData.isSegment ? 'head' : 'all',index,item.prop)">
                        <price-blurring
                          :price-display-type="countData.priceDisplayType"
                          :price="scope.row[item.prop] ? scope.row[item.prop] : '/'"
                        />
                      </template>
                      <div v-else>
                        {{ scope.row[item.prop] ? scope.row[item.prop] : '/' }}
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
                <template v-if="countData.isSegment">
                  <div class="messageTag" v-if="countData.deliveryType === 'ZT'">
                    <p>
                      当前报价不支持派送，需到仓自提，提货地址：
                      <span>{{countData.selfAddress || '/' }}</span>
                    </p>
                  </div>
                  <template v-else>
                    <div style="display: flex;align-items: center;margin: 10px 0;position: relative;">
                      <p style="font-size: 16px;">派送报价</p>
                      <div>
                        <p style="margin-left: 50px;font-size: 18px;color: red;" v-if="countData.selfDelivery === 1">注：可支持到仓自提</p>
                        <p style="margin-left: 50px;font-size: 18px;color: red;" v-if="countData.dispatchChargeType === 'PK'">{{ countData.pickupRemarks }}</p>
                      </div>
                      <!---->
                      <div v-if="countData.isSegment && !countData.whetherAllNeedInquiry && countData.selfDelivery === 2 && countData.deliveryType !== 'ZT' && !countData.whetherExemptionType" style="position: absolute;right: 0;">
                        <template v-if="countData.dispatchChargeType == 'KG'">
                          <div>
                            <div>
                              <span style="color: #999999">{{ countData.isSegment ? '派送' : '' }}体积重比率 ：</span>
                              {{ countData.dispatchVolumeWeightRatio }}
                              <el-tooltip class="item" effect="dark" placement="top-start">
                                <div slot="content" style="max-width: 220px">
                                  <span>体积重比率用于计算体积重，体积重=长*宽*高/体积重比率</span><br />
                                  <span>例如:100CM*100CM*100CM规格的箱子，若体积重比率=6000，则体积重=100*100*100/6000≈167KG</span>
                                </div>
                                <!-- <img style="vertical-align: middle;margin-left: 8px;margin-bottom: 4px;" src="@/assets/imgs/icon_explain.png" alt=""/> -->
                                <i  style="color:#e6a23c;vertical-align: middle;margin-left: 8px;margin-bottom: 4px;font-size:16px" class="el-icon-question"></i>
                              </el-tooltip>
                            </div>
                          </div>
                        </template>
                        <template
                          v-if="countData.dispatchWeightVolumeRatioDesc && countData.dispatchChargeType == 'CBM'
                            "
                        >
                          <div>
                            <div class="" style="color: #999999">
                              {{ countData.isSegment ? '派送' : '' }}重量转换：<span style="color: black">{{
                                countData.dispatchWeightVolumeRatioDesc
                              }}</span>
                            </div>
                          </div>
                        </template>
                      </div>
                    </div>
                    <el-table
                      size="mini"
                      border
                      style="width: 100%"
                      :fit="true"
                      :data="filterDeliveryTableData"
                      :span-method="deliverySpanMethod"
                      :row-class-name="selectedRowClassName"
                    >
                      <el-table-column
                        align="center"
                        :prop="item.prop"
                        :label="item.label"
                        v-for="(item, index) in deliveryTheadData"
                        :key="index"
                        :min-width="item.label && item.label.includes('目的国') ? '150px' : ''"
                      >
                        <template v-slot:header v-if="item.label && item.label.includes('目的国')">
                          <div style="display:flex;align-items: center;justify-content: center">
                            <span style="margin-right: 10px;">{{ item.label }}</span>
                            <region-filter
                              :key="`n2_${item.prop}`"
                              @handleFilter="getRegionForSelect('delivery')"
                              :isZipCode="checkVisibleLookZipCodeRegion('delivery')"
                              type="delivery"
                              @search="handleRegionSearch"
                              @clear="handleRegionSearchReset"
                              :list="allRegionList">
                              <el-button style="color:#FF8745;font-size: 12px" type="text" icon="el-icon-search">筛选</el-button>
                            </region-filter>
                          </div>
                        </template>
                        <template slot-scope="scope">
                          <template v-if="index ===0 && checkVisibleLookZipCodeRegion('delivery')">
                            <el-link
                              @click.prevent="showZipCodeSearch('delivery',scope.row[item.prop], scope.$index)"
                              :underline="false"
                              style="text-decoration:underline;">
                              <template>
                                <div v-html="getRegionHighLight(scope.row[item.prop], 'delivery')"></div>
                              </template>
                              <!--<template v-else>-->
                              <!--  {{ scope.row[item.prop] ? scope.row[item.prop] : "/" }}-->
                              <!--</template>-->
                            </el-link>
                          </template>
                          <template v-else-if="index ===0 && !checkVisibleLookZipCodeRegion('delivery')">
                            <region-detail
                              :list="regionList"
                              :searchText="podlandName"
                              @show="getRegionList('delivery', scope.row[item.prop], scope.$index)">
                              <div>
                                <el-link
                                  style="text-decoration:underline;"
                                  :underline="false">
                                  <template>
                                    <div v-html="getRegionHighLight(scope.row[item.prop], 'delivery')"></div>
                                  </template>
                                  <!--<template v-else>-->
                                  <!--  {{ scope.row[item.prop] ? scope.row[item.prop] : "/" }}-->
                                  <!--</template>-->
                                </el-link>
                              </div>
                            </region-detail>
                          </template>
                          <template v-else-if="isPriceColumn('delivery',index,item.prop)">
                            <price-blurring
                              :price-display-type="countData.priceDisplayType"
                              :price="scope.row[item.prop] ? scope.row[item.prop] : '/'"
                            />
                          </template>
                          <div v-else>
                            {{ scope.row[item.prop] ? scope.row[item.prop] : '/' }}
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                  </template>
                </template>
              </div>
            </el-tab-pane>
            <el-tab-pane label="产品附加费" name="product" v-if="productList.length">
              <div>
                <el-table :data="productList" border stripe>
                  <el-table-column type="index" label="序号" width="70px" align="center">
                  </el-table-column>
                  <el-table-column align="center" v-for="(col, index) in productColumn"
                                   :prop="col.prop"
                                   :key="index"
                                   :label="col.label">
                    <template slot-scope="scope">
                      <template v-if="col.prop === 'namec'">
                        <el-tooltip :content="scope.row[col.prop]" placement="top" popper-class="cus-popper">
                          <div class="product-name-overflow">
                            {{ scope.row[col.prop].slice(0,100) }}...
                          </div>
                        </el-tooltip>
                      </template>
                      <template v-else>{{scope.row[col.prop]||"-"}}</template>
                    </template>
                  </el-table-column>
                </el-table>

              </div>
            </el-tab-pane>

          </el-tabs>

        </div>

        <div style="padding: 15px 0">
          <el-tabs v-model="activeName" @tab-click="TabClick">
            <el-tab-pane label="下单须知" style="font-size:16px" name="first">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="countData.orderInformation"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="特殊要求" name="second">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="countData.specialRequirements"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="温馨提示" name="third">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="countData.warmPrompt"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="包装要求" name="fourth">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="countData.packagingRequirements"
              ></div>
            </el-tab-pane>
            <el-tab-pane label="赔付标准" name="standards">
              <div
                style="max-height: 300px; overflow: auto;color: #666;font-size: 14px;"
                v-html="countData.compensationStandards"
              ></div>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </div>
    <zip-code-region-search
      :visible.sync="visibleZipCode"
      :list="zipCodeRegionList"
      />
  </div>
</template>

<script>
import {qrCodeImages} from "../../../../devParams";
import ZipCodeRegionSearch from "@/components/placeOrder/components/zipCodeRegionSearch";
import regionDetail from "@/components/placeOrder/components/regionDetail/index.vue";
import goodsDetailList from "./goodsDetailList"
import {isArray, isObject} from "my-tools-kit";
import PriceBlurring from "../../../../common/priceBlurring";
import TransferPriceTable from "@/components/placeOrder/components/transferPriceTable";
import regionFilter from "../components/regionFilter.vue";
import {deepCopy} from "iview/src/utils/assist";
import {mapState} from "vuex";

export default {
  components: {TransferPriceTable, PriceBlurring, ZipCodeRegionSearch, regionDetail, goodsDetailList, regionFilter},
  props: {
    val: {
      type: Number,
    },
    type: {
      type: Boolean,
      default: false,
    },
    showStatus: Boolean,
    countData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    tableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    theadData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    deliveryTheadData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    deliveryTableData: {
      type: Array,
      default: () => {
        return [];
      },
    },
    BillItem: {
      type: Object,
      default: () => {
        return {};
      },
    },
    payType: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    // 是否需要转运
    isTransfer:Boolean,
    podlandType: {
      type: Number | String,
      default: 0
    },
    podlandName: '',
    showButton: {
      type: Boolean,
      default: true
    },
    endCountryName: {
      type: String,
      default: ''
    },
    // 目的国家（当为多国家时，regionType === 6，查看详情需要保存当前的目的国家参数）
    beforeToCountryName:String,
  },
  data() {
    return {
      qrCodeImages,
      activeName: "first",
      tabCurrent: 'head',
      productColumn: [
        {
          label: '产品分类',
          prop: 'productTypeName'
        },
        {
          label: '产品品名',
          prop: 'namec'
        },
        {
          label: '附加费',
          prop: 'surcharge'
        },
        {
          label: '币种',
          prop: 'currency'
        },
        {
          label: '计费单位',
          prop: 'billingUnit'
        }
      ],
      productList: [],
      /* 搜索邮编分区 */
      // 邮编分区搜索弹窗显示状态
      visibleZipCode:false,
      zipCodeRegionList:[],
      regionList: [],
      goodsDetailList: [],
      goodsTableLoading: false,
      allRegionList: [],
      filterTableData: deepCopy(this.tableData),
      filterDeliveryTableData: deepCopy(this.deliveryTableData),
      headerFilterCode: '',
      deliveryFilterCode: '',
      priceTypeName: {
        EC: 'FBA报价',
        NON: '私人地址报价',
        'EC&NON': 'FBA和私人地址报价'
      },
      transportCodeMapping: {
        KY: '航空',
        HY: '船运',
        LY: '陆运'
      }
    };
  },
  watch: {
    showStatus(newVal) {
      if (!newVal) this.activeName = "first";
    },
    // BillItem: {
    //   immediate: true,
    //   handler(val) {
    //     this.getProductTrail()
    //   }
    // },
    type: {
      immediate: true,
      handler(newVal, oldVal) {
      if (newVal) {
          this.activeName = "first";
          this.tabCurrent = 'head'
          this.getProductTrail()
        }
      }
    },
  },
  computed: {
    // 全包/头程列表 中属于价格列的index
    headPriceIndexList(){
      let headList = this.theadData;
      let indexList = [];
      headList.forEach((item,index)=> {
        if([0,1,2].includes(index)) return false;
        let isAging = `${item.label||""}`.match("时效");
        if(isAging) return false;
        indexList.push(item);
      });
      return indexList;
    },
    // 派送列表 中属于价格列的index
    deliveryHeadPriceIndexList(){
      let headList = this.deliveryTheadData;
      let indexList = [];
      headList.forEach((item,index)=> {
        if([0].includes(index)) return false;
        let isAging = `${item.label||""}`.match("时效");
        if(isAging) return false;
        indexList.push(item);
      });
      return indexList;
    },
    ...mapState(["isOpen"])
  },
  methods: {
    getGoodsDetails(val) {
      console.log(val)
      const productTypeFirstName = val.split('/')
      // goodsDetailList goodsTableLoading
      // /product/getProductListByCountryAndType
      this.goodsTableLoading = true
      this.axios.post('/product/getProductListByCountryAndType', {
        countryId: this.countData.countryId,
        // productPriceHeaderId: this.countData.productPriceHeaderId,
        productTypeFirstName
      }).then(res => {
        console.log(res)
        this.goodsTableLoading = false
        this.goodsDetailList = res.data.datas || []
      }).catch(() => {
        this.goodsTableLoading = false
      })
    },
    resetProductData(data = []) {
      // data = [
      //   { productTypeId: 1, namec: '11' },
      //   { productTypeId: 1, namec: '22' },
      //   { productTypeId: 2, namec: '33' },
      //   { productTypeId: 2, namec: '44' },
      //   { productTypeId: 2, namec: '55' },
      //   { productTypeId: 3, namec: '66' }
      // ]
      let typeList = data.map(v => {
        return v.productTypeId
      })
      typeList = Array.from(new Set(typeList))
      const result = typeList.map(v => {
        const names = []
        let obj = {}
        data.forEach(el => {
          if (el.productTypeId === v) {
            names.push(el.namec)
            obj = el
          }
        })
        obj.namec = names.join(',')
        delete obj.id
        return obj

      })
      console.log(result)
      return result
    },
    setType(key) {
      const options = {
        ZT: '自提',
        KP: '卡派',
        HK: '海卡',
        HP: '海派',
        WC: '整柜直送',
        FP: '空派',
        KK: '空卡',
        KDP: '快递派',
        KH: '卡航',
        TL: '铁路',
        empty: '-'
      }
      return options[key]
    },
    getProductTrail() {
      // '/api/product/listProductTrial'
      console.log(this.BillItem)
      const data = {
        countryId: this.BillItem.countryId,
        supplierId: this.BillItem.carrierId,
        productPriceHeaderId: this.BillItem.productPriceHeaderId
      }
      this.axios
        .post('/api/product/listProductTrial', data)
        .then((res) => {
          console.log(res);
          if (res.data.code == 200) {
           this.productList = this.resetProductData(res.data.datas)
          } else {
            this.productList = [];
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {
          this.productList = [];
          // this.$message.info("服务器繁忙");
        });
    },
    TabClick() {},
    getUsertypeRap() {
      console.log('555555555');
      this.$parent.$parent.getUsertypeRap({ ...this.BillItem, ...this.countData,chargeType:this.BillItem.chargeType}, null, 'rowPrice');
    },
    // 产品
    followItem() {
      console.log("this.BillItem: ", this.BillItem);
      if (this.BillItem.concernSign) {
        //取消关注
        this.CancelAttention();
        return;
      }
      let data = {
        productOrCountryId: this.BillItem.productId,
        refType: 1,
      };
      this.axios
        .post("/api/product/concernProductOrCountry", data)
        .then((res) => {
          console.log("countryId", res);
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "收藏成功",
            });
            this.BillItem.concernSign = true;
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {
          // this.$message.info("服务器繁忙");
        });
    },
    // 取关
    CancelAttention() {
      let data = {
        productOrCountryId: this.BillItem.productId,
        refType: 1,
      };
      this.axios
        .post("/api/product/cancelConcernProductOrCountry", data)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              type: "success",
              message: "取消收藏",
            });
            this.BillItem.concernSign = false;
            // this.$parent.getProductData();
            this.$emit("getProductData");
            console.log("??????????");
          } else {
            this.$message({
              type: "error",
              message: res.data.message,
            });
          }
        })
        .catch((res) => {
          // this.$message.info("服务器繁忙");
        });
    },
    // 根据可走货物类型合并起运城市及分区单元格
    headSpanMethod({ row, column, rowIndex, columnIndex }) {
      // 合并起运城市
      if (columnIndex === 0) {
        let city = this.tableData[rowIndex].name0
        let sameCityLength = 0
        for (let i = 0; i < this.tableData.length; i++) {
          if (this.tableData[i].name0 === city) {
            sameCityLength++
          }
        }
        const cityFirstAppear = this.tableData.findIndex(item => {
          return item.name0 === city
        })
        if (rowIndex === cityFirstAppear) {
          return [sameCityLength, 1]
        } else {
          return [0, 0]
        }
      }
      // 合并分区
      let area = this.tableData[rowIndex].name1
      let sameAreaLength = 0
      for (let i = 0; i < this.tableData.length; i++) {
        if (this.tableData[i].name1 === area) {
          sameAreaLength++
        }
      }
      const cityFirstAppear = this.tableData.findIndex(item => {
        return item.name1 === area
      })
      if (columnIndex === 1) {
        return [1,1]
        // if (sameAreaLength > 1) {
        //   if (rowIndex === cityFirstAppear) {
        //     return [sameAreaLength, 1]
        //   } else {
        //     return [0, 0]
        //   }
        // }
      }
      // 合并单询
      const rowLength = Object.keys(row).length
      if (row.name3.indexOf('单询') !== -1) {
        const length = rowLength - 5
        if (columnIndex === 3) {
          return [1, length]
        }
        if (columnIndex > 3 && columnIndex < rowLength - 2) {
          return [0, 0]
        }
      }
      // 合并时效
      // if (columnIndex === rowLength - 1 || (!this.countData.isSegment && columnIndex === rowLength - 2)) {
      //   let aging = this.tableData[rowIndex][`name${columnIndex}`]
      //   const agingFirstAppear = this.tableData.findIndex(item => {
      //     return item[`name${columnIndex}`] === aging
      //   })
      //   if (agingFirstAppear > 1) {
      //     if (rowIndex === agingFirstAppear) {
      //       return [sameAreaLength, 1]
      //     } else {
      //       return [0, 0]
      //     }
      //   }
      // }
    },
    deliverySpanMethod({ row, column, rowIndex, columnIndex }) {
      const rowLength = Object.keys(row).length
      if (row.name1.indexOf('免派') !== -1 || row.name1.indexOf('单询') !== -1) {
        const length = rowLength - 1
        if (columnIndex === 1) {
          return [1, length-1]
        }
        if (columnIndex > 1 && columnIndex < length) {
          return [0, 0]
        }
      }
    },
    /**
     * 判断是否展示查看邮编分区弹窗的按钮
     * @param type  {string}  all-全包 head-头程 delivery-派送
     */
    checkVisibleLookZipCodeRegion(type){
      if (type === 'delivery') {
        if (this.countData.deliveryRegionType !== 5) return false
      } else {
        if(this.countData.regionType !== 5) return  false; // 分区类型 regionType： 5-邮编分区
      }
      if(type === "head") return false; // 分段时 头程分区类型为 城市
      return true
    },
    /**
     * 显示 邮编分区 搜索弹窗
     * @param type  {string}  all-全包 head-头程 delivery-派送
     * @param name  {string}  名称/邮编分区名称
     * @param index
     */
    async showZipCodeSearch(type,name, index){
      // 头程(全包)分区：productRegionList
      // 派送分区：deliveryRegionList
      // let ids = type === "delivery" ? this.countData.deliveryRegionList : this.countData.productRegionList;
      // if(!isArray(ids)) return this.$message.error(`分区【${name}】id为空`);
      // let idItem = ids.find(item=>name.includes(item.regionName));
      // if(!idItem || !idItem.id) return this.$message.error(`分区【${name}】对应id为空`);
      const i = type === "delivery" ? this.countData.deliveryRegionPrices[0].length : this.countData.productRegionPrices[0].length
      const el = type === "delivery" ? this.countData.deliveryRegionPrices[index + 1] : this.countData.productRegionPrices[index + 1]
      const regionId = el[i] || ''

      this.getZipCodeRegionList(regionId)
        .then(res=>{
          this.visibleZipCode = true;
        })
        .catch(res=>{
          this.$message.error(`获取邮编分区数据：${res.message||"网络异常"}`);
        })

    },
    hideZipCodeSearch(){
      this.visibleZipCode = false;
    },
    /**
     * 请求邮编分区数据
     */
    getZipCodeRegionList(zipCodeRegionId){
      const data = {
        id:"",
        "countryId": "",//所属国家id
        "regionId": zipCodeRegionId||"",//邮编分区id
        "partitionSchemeName": "",//分区方案名称
      };
      const url = "/api/zipZone/list";
      return this.axios.post(url, data)
        .then(res=>{
          res = isObject(res.data) ? res.data : {};
          if(res.code !== 200) return Promise.reject(new Error(res.message));
          return res;
        })
        .then(res=>{
          let list = res.datas||[];
          this.zipCodeRegionList = list;
          return res
        })
        .catch(res=>{
          this.zipCodeRegionList = [];
          return Promise.reject(res);
        })
    },
    getRegionList(type, name, index) {
      // console.log(name)
      // let ids = type === "delivery" ? this.countData.deliveryRegionList : this.countData.productRegionList;
      // if(!isArray(ids)) return this.$message.error(`分区【${name}】id为空`);
      // let reg =  /[^()]+(?=\()/; // 匹配括号左边的内容
      // let match = name.match(reg);
      // let left = match ? match[0].trim() : '';
      // let idItem = ids.find(item=>left === item.regionName)
      // // let idItem = ids[index]
      // if(!idItem || !idItem.id) return this.$message.error(`分区【${name}】对应id为空`);

				const i = type === "delivery" ? this.countData.deliveryRegionPrices[0].length : this.countData.productRegionPrices[0].length
        const el = type === "delivery" ? this.countData.deliveryRegionPrices[index + 1] : this.countData.productRegionPrices[index + 1]
				const regionId = el[i] || ''

      const data = {
        id:"",
        "countryId": this.countData.countryId,//所属国家id
        "regionId": regionId ? Number(regionId) : '',//分区id
        "partitionSchemeName": "",//分区方案名称
        podlandType: this.podlandType
      };
      // if (this.podlandType !== 0) {
      //   data.podlandType = this.podlandType
      // }
      if (this.countData.regionType === 6 && type !== "delivery") { // 报价为多国家且当前为头程时获取国家id参数调整为匹配分区对应的国家id
        const theRegion = this.countData.productRegionList.find(item=> regionId == item.id)
        data.countryId = theRegion ? theRegion.countryId : this.countData.countryId
      }
      this.axios.post('/api/FBAfee/getRegionDetailByRegionId', data)
        .then(res => {
          this.regionList = res.data.datas || []
        })
    },
    /**
     * 判断是否是价格列
     */
    isPriceColumn(type="all",columnIndex=0,columnValueKey=""){
      // all head delivery
      let isDelivery = type === "delivery";
      let headList = isDelivery ? this.deliveryHeadPriceIndexList : this.headPriceIndexList;
      let column = headList.find(item=>item.prop === columnValueKey);
      return !!column;
    },
    getRegionForSelect(type) {
      this.axios.get(`/api/FBAfee/getRegionDetailForSelect?productPriceHeaderId=${this.countData.productPriceHeaderId}&busType=${this.podlandType}`)
        .then(res => {
          if (res.data.code === 200) {
            let list
            if (type === 'header') {
              list = res.data.data.headerZone
              console.log(res.data.data.headerZone)
            } else {
              list = res.data.data.deliveryZone
            }
            this.allRegionList = list

            console.log('region', this.allRegionList)
          }
        })
    },
    handleRegionSearch(warehouse, regionName, type) {
      let data = deepCopy(type === 'header' ? this.tableData : this.deliveryTableData)
      const key = type === 'header' ? 'name1' : 'name0'
      let list = []
      list = data.filter(item => {
        let pattern = /\((.*?)\)/g; // 匹配括号内的内容

        let matches = item[key].match(pattern);
        let result = matches ? matches.map(match => match.slice(1, -1)) : [];
        result = result[0]
        return result.includes(warehouse)
      })
      // list.forEach(item => {
      //   item[key] = `${regionName}(${warehouse})`
      // })
      if (type === 'header') {
        this.filterTableData = list
        this.headerFilterCode = warehouse
      } else {
        this.filterDeliveryTableData = list
        this.deliveryFilterCode = warehouse
      }
    },
    handleRegionSearchReset(type) {
      if (type === 'header') {
        this.filterTableData = deepCopy(this.tableData)
      } else {
        this.filterDeliveryTableData = deepCopy(this.deliveryTableData)
      }
      this.deliveryFilterCode = ''
      this.headerFilterCode = ''
    },
    /**
     * 价格列表目的国分区要将搜索的目的地标红
     * @param str
     * @param type {string} head头程全包,delivery派送
     * @returns {string}
     */
    getRegionHighLight(str, type) {
      let pattern = /\((.*?)\)/g; // 匹配括号内的内容

      let matches = str.match(pattern);
      if (!matches) {
        return str
      }
      let filterCode = type === 'head' ? this.headerFilterCode : this.deliveryFilterCode
      let result = matches ? matches.map(match => match.slice(1, -1)) : [];
      const inBracket = result[0].split(',')
      result = inBracket.filter(item => {
        return item !== this.podlandName && item !== filterCode
      })
      result.forEach(item => {
        item = item.replace(this.podlandName, '')
        item = item.replace(filterCode, '')
      })

      let reg =  /(.*?)\(/; // 匹配括号左边的内容

      let match = str.match(reg);
      let left = match ? match[0].trim() : '';
      let redText = []
      if (this.podlandName !== '全部' && inBracket.includes(this.podlandName) && (this.countData.regionType !== 6 || (left.includes(this.endCountryName) && this.countData.regionType === 6))) {
        redText.push(this.podlandName)
      }
      if (filterCode && filterCode !== this.podlandName) redText.push(filterCode)
      if (result.length + redText.length > 4) {
        result = result.splice(0, 4 - redText.length)
        result.push('...')
      }
      console.log('red',redText)
      return `
        <div>
            ${left}<span style="color: #FF4D01">${redText.join(',')}${redText.length > 0 && result.length > 0 ? ',' : ''}</span>
            ${result.join(',')})
        <div>
      `
    },
    selectedRowClassName({row}) {
      const key1 = this.headerFilterCode || this.podlandName
      const key2 = this.deliveryFilterCode || this.podlandName
      if (row.name1.includes(key1) || row.name0.includes(key2)) {
        return 'select-row'
      } else {
        return ''
      }
    },
    // isShowHighLight(name, filterCode) {
    //   let pattern = /\((.*?)\)/g; // 匹配括号内的内容
    //   let matches = name.match(pattern);
    //   if (!matches) return false
    //   let result = matches ? matches.map(match => match.slice(1, -1)) : [];
    //   result = result[0].split(',')
    //   let flag = result.some(item => item === this.podlandName)
    //   return flag || filterCode
    // }
  },
  created() {},
  mounted() {
    console.log("get", this.theadData, this.tableData);
    console.log("dialog", this.BillItem);
  },
};
</script>
<style scoped>
.headerItem {
  font-size: 14px;
  line-height: 30px;
  font-weight: 500;
  color: #333333;
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 20px;
}
.test {
  position: absolute;
  right: 12px;
  top: 0;
}

.gotBtn {
  cursor: pointer;
  margin-top: 24px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #ffffff;
  width: 130px;
  height: 50px;
  background: #FF4D01;
  border-radius: 10px;
  font-size:18px ;
  font-weight: bold;
}

.zxBtn {
  margin-left:13px;
  cursor: pointer;
  margin-top: 24px;
  background: #fff;
  border-radius: 4px;
  display: flex;
  display: -webkit-flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-family: PingFang SC;
  color: #FF4D01;
  width: 130px;
  height: 50px;
  border: 2px solid #FF4D01;
  border-radius: 10px;
  box-sizing: border-box;
  font-size:18px ;
  font-weight: bold;
}

.count_center {
  display: flex;
  display: -webkit-flex;
  align-items: center;
}
.icon_collect {
  width: 35px;
  height: 30px;
  display: inline-block;
  background: url("../../../assets/icon_collection1.png") no-repeat;
}
.icon_collect_pre {
  width: 35px;
  height: 30px;
  display: inline-block;
  background: url("../../../assets/icon_collection1_pre.png") no-repeat;
}

/deep/ .el-table--border th, .el-table__fixed-right-patch {
  background: #f5f5f5 !important;
}

/deep/ .el-tabs__item {
  font-size: 16px;
}
/deep/ .el-tabs__header {
  margin-bottom: 8px;
}
.priceTab /deep/ .el-tabs__nav-wrap::after {
  display: none;
}
.messageTag {
  margin-top: 10px;
  display: inline-block;
  width: 100%;
  background-color: #fff6e6;
  color: #ffbf4d;
  border-radius: 5px;
  padding: 12px 18px;
  box-sizing: border-box;
  margin-bottom: 10px;
}
.transfer-table-tag{
  box-sizing: border-box;
  min-width: 44px;
  line-height: 26px;
  padding: 0 6px;
  text-align: center;
  background: inherit;
  background-color: rgba(245, 154, 35, 0.6);
  -moz-box-shadow: none;
  -webkit-box-shadow: none;
  box-shadow: none;
  color: #FFFFFF;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
}
.price-time-range {
  margin-bottom: 5px;
  text-align: right;
  position: absolute;
  top: 10px;
  right: 0;
  font-weight: 500;
  font-size: 16px;
}
.price-time-range span {
  font-weight: bold;
  color: #444;
}
.el-table /deep/ .select-row {
  background-color: #f5f7fa;
}
</style>



// WEBPACK FOOTER //
// src/components/placeOrder/placeindexInfo/GetitemBill.vue